module.exports = new __parcel__URL__("de_3.a3625524.png").toString();